export default __webpack_public_path__ + "static/media/blogs_image.b87d12fd.svg";